// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"90fbea66","314":"e9b79a70","956":"f844dd78"}[chunkId] + ".chunk.js";
};